// This file configures the initialization of Sentry for the creator app.
// https://docs.sentry.io/platforms/javascript/guides/react/

import * as Sentry from '@sentry/react'

export const initSentry = () => {
  if (import.meta.env.MODE !== 'development') {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,

      // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
      tracesSampleRate: 1,

      // Define how likely Replay events are sampled.
      // This sets the sample rate to be 10%. You may want this to be 100% while
      // in development and sample at a lower rate in production
      replaysSessionSampleRate: 0.1,

      // Define how likely Replay events are sampled when an error occurs.
      replaysOnErrorSampleRate: 1.0,

      // Setting this option to true will print useful information to the console while you're setting up Sentry.
      debug: false,

      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,

      // Add optional integrations for additional features
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
    })
  }
}

export { Sentry }
